<div class="modal-dialog cancelBooking_Modal" role="document">
    <div class="modal-content  cancelBooking_sec">
        <div class="modal-body mdl_body  p-0">
            <div class="cancelBooking_container text-center">
                <div class="mb-3">
                    <img src="../../../../assets/icons/dashboard_Icons/cancel-booking.svg" alt="cancel-booking" />
                    <div>
                        <p translate>Are you sure you want to cancel this booking?</p>
                    </div>
                </div>
                <div class="text-center btn_sec">
                    <button class="btn cancel_btn mr-3" data-dismiss="modal" [disabled]="isLoading">Don't
                        Cancel</button>
                    <button class="btn sub_btn primary_CTA" (click)="confirmCancelBooking()" [disabled]="isLoading">
                        <i class="fa fa-spinner fa-spin mr-2" [hidden]="!isLoading" aria-hidden="true"></i>Yes,Cancel
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
